module.exports = __webpack_public_path__ + "img/promo.5b764a1.jpg";